/**
 * Hooks del dashboard de impacto (spec 007-dashboard-impacto)
 */

import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';
import type {
  DashboardFilter,
  DashboardStats,
  DashboardTrends,
  TrendGranularity,
} from '@/types/dashboard';

export function useDashboardStats(filter: DashboardFilter = 'this_month') {
  return useQuery({
    queryKey: ['dashboard-stats', filter],
    queryFn: async () => {
      const response = await api.get<DashboardStats>('/v1/admin/dashboard/stats', {
        params: { filter },
      });
      return response.data;
    },
    staleTime: 1000 * 60 * 5,
  });
}

export function useDashboardTrends(granularity: TrendGranularity = 'month') {
  return useQuery({
    queryKey: ['dashboard-trends', granularity],
    queryFn: async () => {
      const response = await api.get<DashboardTrends>('/v1/admin/dashboard/trends', {
        params: { granularity },
      });
      return response.data;
    },
    staleTime: 1000 * 60 * 15,
  });
}
